import { render, staticRenderFns } from "./SwitchCompany.vue?vue&type=template&id=43483809&scoped=true&"
import script from "./SwitchCompany.vue?vue&type=script&lang=js&"
export * from "./SwitchCompany.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCompany.vue?vue&type=style&index=0&id=43483809&prod&lang=scss&scoped=true&"
import style1 from "./SwitchCompany.vue?vue&type=style&index=1&id=43483809&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43483809",
  null
  
)

export default component.exports